// export const process.env.REACT_APP_BASE_URL = "https://shifttracker.net/api/";
// export const API_URL = "http://localhost:80/api/";
// export const API_URL = "http://127.0.0.1:8080/api/";
export const API_URL = process.env.REACT_APP_BASE_URL;
// macOS
// REACT_APP_NOT_SECRET_CODE=abcdef npm start
// REACT_APP_BASE_URL=https://shifttracker.net/api/ npm start
// Windows
// ($env:REACT_APP_NOT_SECRET_CODE = "abcdef") -and (npm start)
// ($env:REACT_APP_BASE_URL = "https://shifttracker.net/api/") -and (npm start)
